export default __webpack_public_path__ + "static/media/stephanie.b83f3097.png";